import { useNavigate, useParams, generatePath } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { logoutUser } from "../store/slices/UserSlice";
//import { useState } from "react";
import mem from "../assets/img/member.png";
import pro from "../assets/img/property.png";
import lout from "../assets/img/logout.png";
import lead from "../assets/img/lead.png";
// import fra from "../assets/img/Frame.png";
import insplogo from "../assets/img/inspectionlogo.png";
import adminlogo from "../assets/img/adminlogo.png";

const SidebarIcons = () => {
  const { clientNameParam } = useParams();
  const navigate = useNavigate();
  const { userObj } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  //const [isOpen, setIsOpen] = useState(false);

  return (
   <div className="mobile-footer-nav">
  {userObj?.isAdmin && (
    <>
      <button onClick={() => navigate(
        generatePath("/client/:clientNameParam/members", {
                clientNameParam,
              })
        )} title="Members">
        <img src={mem} className="footer-icon" alt="Members" />
      </button>
      <button onClick={() => navigate(
        generatePath("/client/:clientNameParam/siteDashboard", {
                clientNameParam,
              })
        )} title="Properties">
        <img src={pro} className="footer-icon" alt="Properties" />
      </button>
      <button onClick={() => navigate(
        generatePath("/client/:clientNameParam/inspectionDashboard", {
        clientNameParam,
      })
      )} title="Inspection">
        <img src={insplogo} className="footer-icon" alt="Inspection" />
      </button>
      <button onClick={() => navigate(
        generatePath("/client/:clientNameParam/leadDashboard", {
        clientNameParam,
      })
      )} title="Lead">
        <img src={lead} className="footer-icon" alt="Lead" />
      </button>
      <button onClick={() => navigate(
        generatePath("/client/:clientNameParam/adminDashboard", {
                clientNameParam,
              })
              )} title="Admin">
        <img src={adminlogo} className="footer-icon" alt="Admin" />
      </button>
    </>
  )}
  <button
    onClick={() =>
      dispatch(
        logoutUser({
          userId: userObj?.userId,
          userIdentifier: userObj?.userEmail,
        })
      )
    }
    title="Sign Out"
  >
    <img src={lout} className="footer-icon" alt="Sign Out" />
  </button>
</div>

  );
};

export default SidebarIcons;
